import { FC } from "react";
import { AppBar, Button, IconButton, Toolbar } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from "@mui/material/Typography";
import { useBackButtonHandler } from "@utils/useBackButtonHandler";
export interface DialogAppBarProps {
  onClose: () => void
}
export  const DialogAppBar: FC<DialogAppBarProps> = ({onClose}) =>{
  const onCloseHandler = () => {
    onClose()
  }
  useBackButtonHandler(onCloseHandler)
  return (<AppBar sx={{
    position: 'relative',
    backgroundColor: "var(--Schemes-Surface)"
  }}>
    <Toolbar>
      <IconButton onClick={onCloseHandler}>
        <ArrowBackIcon sx={{
          color: "var(--Schemes-On-Surface)",
        }} />
      </IconButton>
      <Typography sx={{
        fontSize: "22px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "28px",
        color: "var(--Schemes-On-Surface)",
      }}>
        Участники
      </Typography>
    </Toolbar>
  </AppBar>)
}